module.exports = __webpack_public_path__ + "src/assets/img/share.35b3cb25.png";